import React, {useRef, useEffect, ReactElement} from 'react';
import { ModalOverlay, ModalWrapper } from './styles';

interface ModalProps {
    isOpen: boolean,
    onClickOutside?: () => void,
    children?: ReactElement | ReactElement[],
}

export const Modal = ({ isOpen, onClickOutside, children }: ModalProps) => {
    const modalRef = useRef<HTMLDivElement>(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleClickOutside = (event: MouseEvent) => {
        if(onClickOutside){
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                onClickOutside();
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClickOutside]);

    return (
        <ModalOverlay isOpen={isOpen}>
            <ModalWrapper ref={modalRef}>
                {children}
            </ModalWrapper>
        </ModalOverlay>
    );
};
